"use strict";

require("../../style/index.css");

require("./index.css");


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/antd/lib/button/style/css.js
// module id = 509
// module chunks = 20